<template>
  <div class="login-wrap">
    <v-card class="login-card" elevation="10">
      <div class="text-center pt-8 px-6">
        <div class="login-logo mb-4">
          <v-icon size="38" color="white">local_shipping</v-icon>
        </div>
        <h1 class="login-title">{{$t("login.text")}}</h1>
        <div class="login-sub">Zaloguj się do panelu</div>
      </div>
      <v-card-text class="px-6 pt-2">
        <v-form @submit.prevent="login">
          <v-text-field
            outlined
            prepend-inner-icon="person"
            name="login"
            :label="$t('login.account')"
            type="text"
            autofocus
            v-model="model.username"
          ></v-text-field>
          <v-text-field
            outlined
            prepend-inner-icon="lock"
            :append-icon="show ? 'visibility_off' : 'visibility'"
            @click:append="show = !show"
            name="password"
            :label="$t('login.password')"
            id="password"
            :type="show ? 'text' : 'password'"
            v-model="model.password"
            @keyup.enter="login"
          ></v-text-field>
          <v-btn block large color="primary" class="login-btn" @click="login" :loading="loading">
            {{$t("login.submit")}}
          </v-btn>
        </v-form>
      </v-card-text>
      <div class="login-foot">Avimex · TransportApp</div>
    </v-card>
  </div>
</template>

<script>
import router from "../../router/"
const axios = require('axios');
import moment from 'moment'
export default {
  data: () => ({
    loading: false,
    show: false,
    model: {
      username: "",
      password: ""
    }
  }),

  mounted(){
    function getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

  },
  methods: {
    login() {
   function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

    if(this.model.username!="" && this.model.password !=""){
      this.loading = true
      var data = this;
     axios.post('http://'+location.hostname+'/transportapp/php_file/login.php', {
       request: 1,
       name: data.model.username,
       pass: data.model.password,
       data: moment().format("YYYY-MM-DD 00:00:00")
     })
     .then(function (response) {
      if(response.data.message=="failed"){data.loading=false; data.store.state.snackbar.text ="Nieprawidłowe dane";}
      else if(response.data.message="loginok"){
        data.store.state.snackbar.text="Zalogowano";
        setCookie("jwt", response.data.jwt, 1);
        setTimeout(() => {
        data.$router.push("/dashboard")
      }, 1000)
      }else data.loading=false
        data.store.state.snackbar.show=true;
     })
     .catch(function (error) {
       console.log(error);
     });


   /*   setTimeout(() => {
        this.$router.push("/dashboard")
      }, 1000)*/
    }
  }
  }
}
</script>

<style scoped lang="css">
.login-wrap {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(1200px 600px at 18% -10%, #dbeafe 0%, transparent 55%),
    radial-gradient(1000px 500px at 100% 110%, #e0e7ff 0%, transparent 50%),
    #F1F5F9;
}
.login-card {
  width: 410px;
  max-width: 92vw;
  border-radius: 18px !important;
  overflow: hidden;
}
.login-logo {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  border-radius: 20px;
  background: linear-gradient(135deg, #2563EB, #6366F1);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 24px rgba(37, 99, 235, .35);
}
.login-title { font-size: 24px; font-weight: 800; letter-spacing: -.3px; margin: 0; color: #1E293B; }
.login-sub { color: #64748B; font-size: 14px; margin-top: 4px; }
.login-btn { text-transform: none; font-weight: 700; letter-spacing: .3px; border-radius: 12px; margin-top: 4px; }
.login-foot { text-align: center; color: #94A3B8; font-size: 12px; padding: 8px 0 18px; }
</style>
